import { useEffect } from "react";
import { useGLTF } from "@react-three/drei";
import type { Group } from "three";

interface SiteModelProps {
  /** 모델 URL — 백엔드 /sites API 의 Site.modelFile.url. 사이트별로 다르다. */
  url: string;
  /** GLTF 로드 완료 시 root scene 전달 (floor index 빌드 + occlusion raycast용). */
  onLoad?: (root: Group) => void;
}

export function SiteModel({ url, onLoad }: SiteModelProps) {
  const { scene } = useGLTF(url);

  // Suspense 통과 후 scene이 준비되면 1회 통지. onLoad는 호출부에서 useCallback 권장.
  useEffect(() => {
    if (scene) onLoad?.(scene as Group);
  }, [scene, onLoad]);

  return <primitive object={scene} />;
}
